module.exports = __webpack_public_path__ + "img/pic5.9f640e8a.png";